import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import DestinationPage from "./pages/DestinationPage";
import HomePage from "./pages/HomePage";
import "./App.css";

const App = () => {
	return (
		<BrowserRouter>
			<div className="App">
				<Header />
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/destinations/:slug" element={<DestinationPage />} />
				</Routes>
			</div>
		</BrowserRouter>
	);
};

export default App;
